import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '../menu/header2';

import poopy from '../../../src/assets/poopy.png';
import rekt from '../../../src/assets/rekt.mp4';

const Poopyheads = () => {
  return (
    <>
      <Header />
      {/* Container with top padding equal to your header's height */}
      <Container
        fluid
        style={{
          backgroundColor: '#ffffff',
          padding: '20px',
          paddingTop: '100px' // Adjust this value to match your header's height
        }}
      >
        <Row>
          {/* Left column: Images and video */}
          <Col md={7}>
            <img
              src={poopy}
              alt="Poopyheads NFT"
              style={{
                width: '80%',
                height: 'auto',
                paddingBottom: '2em'
              }}
            />
            <video src={rekt} controls style={{ height: '20em' }}></video>
          </Col>

          {/* Right column: Content */}
          <Col md={5} style={{ color: 'black' }}>
            <h1>Poopyheads NFT Collection</h1>
            <h3>Generative Collectibles on Ethereum</h3>
            <h4>
              <a href="https://opensea.io/collection/poopyheadsnft">
                See the collection on Open Sea
              </a>
            </h4>
            <p>
              Poopyheads is a collection of 555 generative collectibles on the Ethereum blockchain.
            </p>
            <h3>Key Features</h3>
            <ul>
              <li>Very rare collectibles with unique features</li>
              <li>Sold out collection</li>
              <li>Discord Community</li>
              <li>Unique Designs</li>
            </ul>
            <h3>Challenges</h3>
            <p>
              We wanted to know if there was still a market for NFTs. We came up with the most unappealing concept we could, and the challenge was to make it appealing through branding and marketing. We were surprised to find out that there is indeed an audience and our collection sold out within 5 minutes!
            </p>
            <br />
            <p>
              Marketing was then our greatest challenge in conveying the spirit of the project. We succeeded and were able to gain over 2,000 users on Twitter and an engaged audience on Discord within a short time.
            </p>
            <br />

            {/* Two rows with two columns each */}
            <Row className="mt-3">
              <Col xs={6}>
                <h3>Completion Date</h3>
                <p>2023</p>
              </Col>
              <Col xs={6}>
                {/* Optionally add client or additional info here */}
              </Col>
            </Row>

            <Row className="mt-3">
              <Col xs={6}>
                <h3>Skills Used</h3>
                <p>
                  Smart Contract development, Website development, Branding, Brand Strategy, 2D Content Design, Video and Animation Design
                </p>
              </Col>
              <Col xs={6}>
                <h3>Technology Used</h3>
                <p>
                  Solidity for Smart Contracts, React, Adobe Creative Cloud
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Poopyheads;
